import { type ReactNode } from 'react';
import { RadioGroup as RACRadioGroup, type RadioGroupProps as RACRadioGroupProps } from 'react-aria-components';
import { cn } from '../../../components/utils';
import type { BaseFieldProps } from '../../../components/types';
import { FieldDescription } from '../base-controls/FieldDescription';
import { FieldLabelWithHtml } from '../base-controls/FieldLabelWithHtml';
import { FieldError } from '../base-controls/FieldError';
import clsx from 'clsx';
import type { RadioProps } from '../base-controls/Radio';

export interface RadioGroupFieldProps extends Omit<RACRadioGroupProps, 'children'>, BaseFieldProps {
	size?: RadioProps['size'];
	children?: ReactNode;
}

export function RadioGroupField(props: RadioGroupFieldProps) {
	return (
		<RACRadioGroup
			{...props}
			className={cn('group relative flex gap-2', props.orientation === 'horizontal' ? 'flex-row items-center' : 'flex-col', props.className)}
			aria-label={props.label}
			isRequired={props.required}
		>
			<div className={clsx('flex flex-col', props.description && 'gap-1')}>
				{!props.hideLabel ? <FieldLabelWithHtml className="mb-1" label={props.label} required={props.required} /> : null}
				{props.description && <FieldDescription>{props.description}</FieldDescription>}
			</div>

			<div className="flex flex-col group-orientation-horizontal:flex-row group-orientation-horizontal:items-center group-orientation-horizontal:gap-2">
				{props.children}
			</div>
			{props.error && <FieldError {...props.error} />}
		</RACRadioGroup>
	);
}
